class FarloUiTicketCalendar {
    constructor(element, _config) {
        this.container = element;
        this.options = _config;
        this.minDate = new Date(this.container.dataset.startMonth);
        this.maxDate = new Date(this.container.dataset.endMonth);
        if (this.container.dataset && this.container.dataset.startMonth) {
            this.currentDate = new Date(this.container.dataset.startMonth);
        } else {
            this.currentDate = new Date();
        }
        this.render();
    }


    padString(value) {
        if (value < 10) {
            return "0" + value;
        }
        return value;
    }


    renderHeader() {
        const header = document.createElement('div');
        header.classList.add('farlo-ui-ticket-calendar__header');
    
        const prevButton = document.createElement('button');
        prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
        prevButton.innerHTML = '&#10094;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) >
        parseInt(this.minDate.getFullYear().toString() + this.padString(this.minDate.getMonth()), 10)) {
            prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            prevButton.addEventListener('click', () => this.prevMonth());
        } else {
            prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        const title = document.createElement('h2');
        title.classList.add('farlo-ui-ticket-calendar__header-month-year');
        title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
    
        const nextButton = document.createElement('button');
        nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
        nextButton.innerHTML = '&#10095;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) <
            parseInt(this.maxDate.getFullYear().toString() + this.padString(this.maxDate.getMonth()), 10)) {
            nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            nextButton.addEventListener('click', () => this.nextMonth());
        } else {
            nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        header.appendChild(prevButton);
        header.appendChild(title);
        header.appendChild(nextButton);
    
        this.container.appendChild(header);
        this.renderAvailabilityKey();
    }
    
    renderAvailabilityKey() {
        const availabilityKey = document.createElement('div');
        availabilityKey.classList.add('farlo-ui-ticket-calendar__availability-key');
    
        const keys = [
            { label: 'Sold Out', class: 'sold-out' },
            { label: 'Last Few', class: 'last-few-tickets' },
            { label: 'Selling Fast', class: 'selling-fast' },
            { label: 'Available', class: 'available-tickets' },
        ];
    
        keys.forEach(key => {
            const keyItem = document.createElement('div');
            keyItem.classList.add('farlo-ui-ticket-calendar__key-item', key.class);
            keyItem.textContent = key.label;
            availabilityKey.appendChild(keyItem);
        });
    
        this.container.appendChild(availabilityKey);
    }
    

    renderDaysOfTheWeeks() {
        const div = document.createElement('div');
        div.classList.add('farlo-ui-ticket-calendar__weeks');
        const daysLetters = ['M<span>on</span>', 'T<span>ue</span>', 'W<span>ed</span>', 'T<span>hu</span>', 'F<span>ri</span>', 'S<span>at</span>', 'S<span>un</span>'];

        for (let i = 0; i < 7; i += 1) {
            const days = document.createElement('div');
            days.classList.add('farlo-ui-ticket-calendar__week-day');
            days.innerHTML = daysLetters[i];
            div.appendChild(days);
        }

        this.container.appendChild(div);
    }

    getUKDay(date) {
        let day = date.getDay();
        return day === 0 ? 6 : day - 1;
    }

    renderDaysInMonth() {
        const daysContainer = document.createElement('div');
        daysContainer.classList.add('farlo-ui-ticket-calendar__days');
    
        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();
    
        const firstDay = this.getUKDay(new Date(year, month, 1));
        const daysInMonth = new Date(year, month + 1, 0).getDate();
    
        for (let i = 0; i < firstDay; i++) {
            const blankDay = document.createElement('div');
            blankDay.classList.add('farlo-ui-ticket-calendar__day', 'farlo-ui-ticket-calendar__day--empty');
            daysContainer.appendChild(blankDay);
        }
    
        for (let day = 1; day <= daysInMonth; day++) {
            const dayElement = document.createElement('div');
            dayElement.classList.add('farlo-ui-ticket-calendar__day');
            
            const dayNumber = document.createElement('div');
            dayNumber.classList.add('farlo-ui-ticket-calendar__day-number');
            dayNumber.textContent = day;
            dayElement.appendChild(dayNumber);
    
            const eventDate = new Date(Date.UTC(year, month, day)).toISOString().split('T')[0];
            const eventsOnThisDay = nlivenPerformances.filter(event => event.start_date_time.startsWith(eventDate));
    
            if (eventsOnThisDay.length > 0) {
                eventsOnThisDay.forEach(event => {
                    const eventElement = document.createElement('div');
                    eventElement.classList.add('farlo-ui-ticket-calendar__event');
                    
                    const eventTime = new Date(event.start_date_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    const eventInfo = document.createElement('div');
                    eventInfo.classList.add('farlo-ui-ticket-calendar__event-info');
    
                    const availability = parseInt(event.availability);
                    let availabilityClass = '';
                    if (availability === 0) {
                        availabilityClass = 'sold-out';
                    } else if (availability < _farloCalendarConfig.last_few) {
                        availabilityClass = 'last-few-tickets';
                    } else if (availability < _farloCalendarConfig.selling_fast) {
                        availabilityClass = 'selling-fast';
                    } else {
                        availabilityClass = 'available-tickets';
                    }
                    if (availability == 0) {
                        eventInfo.innerHTML = `<a href="javascript:void(0);" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}"><strong>${eventTime}</strong></a>`;
                    } else {
                        eventInfo.innerHTML = `<a href="${event.booking_url}" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}" target="_blank"><strong>${eventTime}</strong></a>`;
                    }
                    eventElement.classList.add(availabilityClass);
    
                    eventElement.appendChild(eventInfo);
                    dayElement.appendChild(eventElement);
                });
            }
    
            daysContainer.appendChild(dayElement);
        }
    
        this.container.appendChild(daysContainer);
    }
    

    async fetchEventsForMonth(y, m) {
        // Clear the container before adding new content
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    async render() {
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    prevMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.render();
    }

    nextMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.render();
    }

    handleEventClick(event) {
        if (this.options.eventClick) {
            this.options.eventClick(event);
        }
    }
}

export default FarloUiTicketCalendar;
